// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

/* CSS */
import "@css/app.pcss";

/* JS */
import 'lazysizes';
import { gsap } from "gsap";    
import { CustomEase } from "gsap/CustomEase";
import { RoughEase, ExpoScaleEase, SlowMo } from "gsap/EasePack";    
import { Flip } from "gsap/Flip";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { Draggable } from "gsap/Draggable";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { TextPlugin } from "gsap/TextPlugin";
/* The following plugins are Club GSAP perks */
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";
import { SplitText } from "gsap/SplitText";
//import * as YTPlayer from 'yt-player';


/* SCRIPTS HERE */


/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import persist from '@alpinejs/persist';

var duration = duration || 1;
gsap.registerPlugin(Flip,ScrollTrigger,ScrollToPlugin,Draggable,MotionPathPlugin,TextPlugin,DrawSVGPlugin,ScrambleTextPlugin,SplitText,RoughEase,ExpoScaleEase,SlowMo,CustomEase);    

document.addEventListener('alpine:init', () => {

  Alpine.store('contentModal', {
      on: false,
      modalHtml: '',
      showLoading: false,   
    
      open(modalUrl, modalTitle) {      
        this.modalHtml='loading...'; 
        this.showLoading = true; 
        this.on = true;
              
        fetch(modalUrl, {
          method: 'GET',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        })
        .then(response => response.text())
        .then(text => {
          this.modalHtml = text
          this.showLoading = false;        
        })
        
      },
      
      close() {
        this.on = false;
        this.modalHtml = '';
        this.showLoading = false;   
      }
    });

  Alpine.data('sectionStandard', (animateContent, staggerAnimations) => ({
    init() {       
      if (animateContent) {
        const animParent = this.$refs.animparent;
        const animSelector = "#" + animParent.getAttribute('id') + " .animate" ;
        const animCast = document.querySelectorAll(animSelector);
        gsap.set(animCast, {
          opacity: 0,
          y: 35
        })
        if (staggerAnimations) {          
          ScrollTrigger.batch(animCast, {
            onEnter: batch => gsap.to(batch, 
            {
              duration: duration * 1,   
              y: 0,
              opacity: 1,
              // Note: Easing Pack required for easing
              ease: "expo.out",
              onComplete() {
                this.postRevealFunction;
              },
              stagger: 0.1      
            }),
            start: "top 80%",
            once: true
          });
        } else {
          animCast.forEach(animItem => {              
            gsap.from(animItem, {       
              duration: duration * 1,
              y: 35,     
              opacity: 0,                   
              // Note: Easing Pack required for easing
              ease: "expo.out",
              onComplete: this.postRevealFunction,                
              scrollTrigger: {
                trigger: animParent,
                start: "top 80%",
              }     
            })
          });
        }
      } else {
        const animElem = this.$refs.animate;
        gsap.from(animElem, {
          duration: duration * 1,
          y: 50,          
          opacity: 0,     
          // Note: Easing Pack required for easing
          ease: "expo.out",
          onComplete: this.postReveal,                
          scrollTrigger: {
            trigger: animElem,
            start: "top 80%",
          }
        })  
      }           
    },
        
    postReveal() {
      
    }    
      
  })),

  Alpine.data('sectionPageHeader', (animateContent, staggerAnimations) => ({
  init() {
      if (animateContent) {
        const animParent = this.$refs.animparent;
        const animSelector = "#" + animParent.getAttribute('id') + " .animate" ;
        const animCast = document.querySelectorAll(animSelector);
        gsap.set(animCast, {
          opacity: 0,
          y: 35
        })
        const split = new SplitText(".page-header-headline-text", {type: "lines", linesClass: 'animate'});
        gsap.to(".bg-reveal", { duration: 1, yPercent: -100, ease: "expo.inOut", stagger: 0.1});
        gsap.from(split.lines, { duration: 1, y: 100, ease: "power4.out", autoAlpha: 0, stagger: 0.1}, '-=0.75');
        if (staggerAnimations) {          
          ScrollTrigger.batch(animCast, {
            onEnter: batch => gsap.to(batch, 
            {
              duration: duration * 1,   
              y: 0,
              opacity: 1,
              // Note: Easing Pack required for easing
              ease: "expo.inOut",
              onComplete() {
                this.postRevealFunction;
              },
              stagger: 0.1      
            }),
            start: "top 80%",
            once: true
          });
        } else {
          animCast.forEach(animItem => {              
            gsap.from(animItem, {       
              duration: duration * 1,
              y: 35,     
              opacity: 0,                   
              // Note: Easing Pack required for easing
              ease: "expo.inOut",
              onComplete: this.postRevealFunction,                
              scrollTrigger: {
                trigger: animParent,
                start: "top 80%",
              }     
            })
          });
        }
      } else {
        const animElem = this.$refs.animate;
        gsap.from(animElem, {
          duration: duration * 1,
          y: 50,          
          opacity: 0,     
          // Note: Easing Pack required for easing
          ease: "expo.inOut",
          onComplete: this.postReveal,                
          scrollTrigger: {
            trigger: animElem,
            start: "top 80%",
          }
        })  
      }                
    },
          
    postReveal() {
        
    }    
        
  })),
  
  Alpine.data('sectionSidePhoto', (animateContent, staggerAnimations) => ({
  init() {
      if (animateContent) {
        const animParent = this.$refs.animparent;
        const animSelector = "#" + animParent.getAttribute('id') + " .animate" ;
        const animCast = document.querySelectorAll(animSelector);
        gsap.set(animCast, {
          opacity: 0,
          x: 35
        })
        if (staggerAnimations) {          
          ScrollTrigger.batch(animCast, {
            onEnter: batch => gsap.to(batch, 
            {
              duration: duration * 1,   
              x: 0,
              opacity: 1,
              // Note: Easing Pack required for easing
              ease: "back.inOut",
              onComplete() {
                this.postRevealFunction;
              },
              stagger: 0.1      
            }),
            start: "top 80%",
            once: true
          });
        } else {
          animCast.forEach(animItem => {              
            gsap.from(animItem, {       
              duration: duration * 1,
              y: -35,     
              opacity: 0,                   
              // Note: Easing Pack required for easing
              ease: "back.out",
              onComplete: this.postRevealFunction,                
              scrollTrigger: {
                trigger: animParent,
                start: "top 80%",
              }     
            })
          });
        }
      } else {
        const animElem = this.$refs.animate;
        gsap.from(animElem, {
          duration: duration * 1,
          y: 50,          
          opacity: 0,     
          // Note: Easing Pack required for easing
          ease: "back.inOut",
          onComplete: this.postReveal,                
          scrollTrigger: {
            trigger: animElem,
            start: "top 80%",
          }
        })  
      }                
    },
          
    postReveal() {
        
    }    
        
  })),

  // What we do BG circles
  gsap.set(".scrub-circle", { yPercent: 25});
  gsap.to(".scrub-circle", {
    yPercent: 40,
    ease: "none",
    scrollTrigger: {
      trigger: ".section-scrub-circle",
      scrub: 1
    }, 
  });

  /* STAT TICKER BEHAVIORS */
  Alpine.data('statisticTicker', (dataPrefix, dataSuffix, dataEndVal, dataStartVal, dataDecimals) => ({
    init() {
      const aniItem = this.$refs.statticker;
      const tickerFunction = function(el, dataPrefix, dataSuffix, dataEndVal, dataStartVal) {
        gsap.to(aniItem, {
          textContent: dataEndVal,
          snap:'textContent',
          duration: 1,
          delay: 0.01,
          scrollTrigger: {
            trigger: aniItem,
            start: "top bottom-=100px",
          }
        });
      };
      gsap.to(aniItem, {      
        duration: 0,
        scale: 1,
        opacity: 1,
        delay: 0.01,
        onComplete: tickerFunction,
        onCompleteParams: [aniItem, dataPrefix, dataSuffix, dataEndVal, dataStartVal, dataDecimals],      
        scrollTrigger: {
          trigger: aniItem,
          start: "top bottom-=100px",
        }     
      });    
    },
        
    postReveal() {
      
    }    
      
  }))
})
  

if (typeof window.Alpine === "undefined") {
  Alpine.plugin(collapse);
  Alpine.plugin(focus);
  Alpine.plugin(persist);
  window.Alpine = Alpine;
  window.Swiper = Swiper;  
  Alpine.start();
}


// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
  console.log("HMR")
  });
}

